import React, {FC} from 'react';

import {Link} from "react-router-dom";
import {Card, Typography} from "@mui/material";
import {sx} from "./sx";
import {useTranslation} from "react-i18next";
import {IStatisticNavigateItem} from '../types'

const Item: FC<IStatisticNavigateItem> = ({path, label}) => {
    const {t} = useTranslation()

    return (
        <Link to={path}>
            <Card sx={sx.root}>
                <Typography sx={sx.name}>
                    {t(label)}
                </Typography>
            </Card>
        </Link>
    );
};

export default Item;